const QuickCart = {
  el: $(".quick-cart"),
  qtyThrottle: undefined,

  init() {
    QuickCart.events();
    QuickCart.quantityEvents();
  },

  /**
   * Open QuickCart
   **/
  open() {
    QuickCart.el.addClass("quick-cart--open");
    $("html").addClass("no-scroll");
  },

  /**
   * Close QuickCart
   **/
  close() {
    QuickCart.el.removeClass("quick-cart--open");
    $("html").removeClass("no-scroll");
  },

  /**
   * Loaded QuickCart
   **/
  loaded() {
    QuickCart.el.addClass("quick-cart--loaded");
  },

  /**
   * QuickCart functionality
   **/
  events() {
    $(".cart-btn:not(.cart-page)").on("click", function (e) {
      e.preventDefault();

      switch (true) {
        case QuickCart.el.hasClass("quick-cart--open"):
          QuickCart.close();
          break;

        case QuickCart.el.hasClass("quick-cart--loaded"):
          if ($(".header").hasClass("header--mobile-open")) {
            $(".header").removeClass("header--mobile-open");
          }
          if ($(".burger").hasClass("active")) {
            $(".burger").removeClass("active");
          }

          QuickCart.open();
          break;

        default:
          QuickCart.render();
          break;
      }
    });

    QuickCart.el.on("click", ".quick-cart__close", function () {
      QuickCart.close();
    });

    $(document).keyup(function (e) {
      if (QuickCart.el.hasClass("quick-cart--loaded")) {
        if (e.keyCode === 27) {
          QuickCart.close();
        }
      }
    });

    $(document).mouseup(function (e) {
      if (QuickCart.el.hasClass("quick-cart--loaded")) {
        var container = QuickCart.el.find(".quick-cart__inner");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          QuickCart.close();
        }
      }
    });
  },

  quantityEvents() {
    QuickCart.el.on("click", ".quantity__button--up", function (e) {
      const inputEl = $(this).siblings("input");

      QuickCart.handleQtyInput(inputEl, "add");

      if (QuickCart.qtyThrottle) {
        return;
      }

      QuickCart.qtyThrottle = setTimeout(() => {
        QuickCart.changeQuantity(inputEl, "add");
        QuickCart.qtyThrottle = undefined;
      }, 1000);
    });

    QuickCart.el.on("click", ".quantity__button--down", function (e) {
      const inputEl = $(this).siblings("input");

      QuickCart.handleQtyInput(inputEl, "remove");

      if (QuickCart.qtyThrottle) {
        return;
      }

      QuickCart.qtyThrottle = setTimeout(() => {
        QuickCart.changeQuantity(inputEl, "remove");
        QuickCart.qtyThrottle = undefined;
      }, 1000);
    });
  },

  handleQtyInput(inputEl, type) {
    let product_qty = parseInt(inputEl.val());

    if (type === "add") {
      if (inputEl.attr("max") <= product_qty + 1) {
        return;
      }
      product_qty++;
    } else if (type === "remove") {
      if (product_qty <= 1) {
        return;
      }
      product_qty--;
    }

    inputEl.val(product_qty);
  },

  changeQuantity(inputEl) {
    QuickCart.el.addClass("quick-cart--loading");

    const product_key = inputEl
      .closest("[data-product-key]")
      .attr("data-product-key");

    const product_qty = parseInt(inputEl.val());

    $.ajax({
      type: "POST",
      url: ajaxurl,
      dataType: "JSON",
      data: {
        action: "handle_change_quantity",
        product_key,
        product_qty,
      },
    }).done((resp) => {
      QuickCart.setCart(resp);
      QuickCart.el.removeClass("quick-cart--loading");
    });
  },

  /**
   * Render quickcart
   **/
  render() {
    QuickCart.open();
    QuickCart.el.html(
      '<div class="quick-cart-loader"><div class="spinner"></div></div>'
    );

    $.ajax({
      type: "POST",
      url: ajaxurl,
      dataType: "JSON",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      if (response) {
        QuickCart.loaded();
        QuickCart.el.html(response);
      } else {
        QuickCart.close();
      }
    });
  },

  /**
   * Set cart item values
   */
  setCart(cart) {
    for (let index = 0; index < cart.items.length; index++) {
      const item = cart.items[index];

      const cartItemEl = $(`[data-product-key="${item.key}"]`);

      cartItemEl.find(".quantity__input").val(item.quantity);

      cartItemEl.find(".cart-item-price").html(item.single_price);

      if (item.has_discount) {
        cartItemEl.find(".price-before-discount").html(item.regular_sum);
        cartItemEl.find(".price-after-discount").html(item.total_price_sum);
      } else {
        cartItemEl.find(".price-after-discount").html(item.total_price_sum);
      }
      if (cartItemEl.find(".cart-item-price-unit").length) {
        cartItemEl.find(".cart-item-price-unit").html(item.price_unit);
      }
    }

    $(".quick-cart-vat").html(cart.price_without_tax);
    $(".quick-cart-vat-only").html(cart.taxes);
    $(".quick-cart-total").html(cart.total);
  },
};

export default QuickCart;
